import { enviarValesPorEmail, enviarXmlsPorEmail } from "@/api/email";
import { FiltroDeCapaDaNota } from "@/models";
import { EmailServiceAdapter } from "@/usecases/email";
import { AxiosRequestConfig } from "axios";

export class EmailService implements EmailServiceAdapter {
	enviarValesPorEmail = async (idVenda: string, email: string) => await enviarValesPorEmail(idVenda, email)

	enviarXmlsPorEmail = async (filtro: FiltroDeCapaDaNota, emailDestino: string, config?: AxiosRequestConfig) => await enviarXmlsPorEmail(filtro, emailDestino, config)
}